

import React, { memo } from "react";

const ReactionTrigger = memo(({ onClick, isVisible }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        absolute -top-2 -right-2
        w-7 h-7
        flex items-center justify-center
        rounded-full
        bg-[var(--bg-surface)]/95 backdrop-blur-md
        border border-white/10
        shadow-lg
        transition-all duration-200 ease-out
        ${isVisible
          ? "opacity-100 scale-100 pointer-events-auto"
          : "opacity-0 scale-75 pointer-events-none"
        }
        hover:scale-110 active:scale-95
        hover:bg-white/10
        focus:outline-none focus:ring-2 focus:ring-indigo-500/50
        z-10
      `}
      aria-label="Add reaction"
      title="Add reaction"
    >
      <svg
        className="w-3.5 h-3.5 text-[var(--text-muted)]"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </button>
  );
});

ReactionTrigger.displayName = "ReactionTrigger";
export default ReactionTrigger;
